import type {
  V2FileStorageFile,
  V2FileStorageFolder,
  V2GetContentsApiResponse,
} from "@generated";

export type TreeFolder = V2FileStorageFolder & {
  type: "folder";
  children: unknown[];
};
export type TreeFile = V2FileStorageFile & { type: "file" };

const asArray = <T>(value: T[] | T | null | undefined): T[] => {
  if (value == null) return [];
  return Array.isArray(value) ? value : [value];
};

/**
 * Turns a `/v2/file-storages/{id}/contents` response into tree nodes. The API
 * sends `null` for an empty list (and the schema allows a lone folder object),
 * so both are normalized to arrays. Keys inside each entry stay snake_case.
 */
export const toFileStorageContents = (
  response: V2GetContentsApiResponse | undefined
): { folders: TreeFolder[]; files: TreeFile[] } => {
  const attributes = response?.data?.attributes;
  const folders = asArray<V2FileStorageFolder>(attributes?.folders).map(
    (folder): TreeFolder => ({ ...folder, type: "folder", children: [] })
  );
  const files = asArray<V2FileStorageFile>(attributes?.files).map(
    (file): TreeFile => ({ ...file, type: "file" })
  );
  return { folders, files };
};
